import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

@Component({
    selector: 'ui-data-row',
    templateUrl: './ui-data-row.component.html'
})
export class UIDataRowComponent implements AfterViewInit {
    @ViewChild('row') row: ElementRef<HTMLElement>

    ngAfterViewInit(): void {
        this.validateForUnknownElements();
        this.removeNoneNativeChildren();
    }

    validateForUnknownElements(): void {
        const allChildren = Array.from(this.row.nativeElement.children) as HTMLElement[];
        const someElementIsNotUIDataRow = allChildren.some(child => !child.tagName || !['UI-DATA-HEADER', 'UI-DATA-CELL'].includes(child.tagName));
        if (someElementIsNotUIDataRow) {
            allChildren.forEach(child => {
                if (!child.tagName || !['UI-DATA-HEADER', 'UI-DATA-CELL'].includes(child.tagName)) {
                    child.remove();
                }
            });

            throw (`${this.constructor.name}: ui-data-row only supports ui-data-cell and ui-data-header elements`);
        }
    }

    removeNoneNativeChildren(): void {
        const allDataElements = Array.from(this.row.nativeElement.children).map(child => Array.from(child.children)).flat();
        this.row.nativeElement.replaceChildren(...allDataElements);
    }
}